import React from 'react'
import * as S from './styles'

import { Modal } from '@mui/material'

interface IModalInformationProps {
  children?: React.ReactNode
  isOpen: boolean
  title?: string
  onCloseModal?: () => void
}

const ModalInformation = ({
  children,
  isOpen,
  onCloseModal,
  title,
}: IModalInformationProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <S.ModalBox>
        <S.ModalTitle>{title}</S.ModalTitle>

        <S.ModalDescription>{children}</S.ModalDescription>
      </S.ModalBox>
    </Modal>
  )
}

export { ModalInformation }
export type { IModalInformationProps }
